// extracted by mini-css-extract-plugin
module.exports = {"container404":"HttpError_container404__3AZjF","container500":"HttpError_container500__DDQZW","box":"HttpError_box__ucoSW","buttons":"HttpError_buttons__e4b8P"};